import React from "react";
import BG from "../assets/No SubcontractorsNew@2x.png";
import Container from "../../../Components/Container";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";

const NoSubContractors = () => {
  return (
    <Container>
      <BGImageDisplay options={{ objpos: "right" }} bgimage={BG} />
    </Container>
  );
};

export default NoSubContractors;
